/* Project Unity core: loaded by sections/header.liquid on every page.
   Header metrics, header solid-on-scroll, assist launcher, contact dialogs,
   FAQ re-measure and the shared restoreFocus helper. */
(function () {
  if (window.__puVisibleMotion) return;
  window.__puVisibleMotion = true;
  const containers = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('pu-motion-visible', entry.isIntersecting));
  }) : null;
  function observe(root) {
    root.querySelectorAll('.pu-story-row, .pu-credibility, .pu-explorer').forEach(element => {
      if (containers.has(element)) return;
      containers.add(element);
      if (observer) observer.observe(element);
      else element.classList.add('pu-motion-visible');
    });
  }
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
  function visibility() { document.documentElement.classList.toggle('pu-page-hidden', document.hidden); }
  document.addEventListener('visibilitychange', visibility);
  visibility();
})();

/* The assist launcher hides while Shopify's cookie banner shows. Stylesheets read that
   from a body class: a body:has(#shopify-pc__banner:not([hidden])) check re-styled the
   whole page on every class or attribute change anywhere (INP). Shopify appends the
   banner to <body> and hides it with an inline display: none. */
(function () {
  if (!('MutationObserver' in window) || window.__puCookieBannerWatch) return;
  window.__puCookieBannerWatch = true;
  let banner = null;
  const isShown = node => Boolean(node && node.isConnected && !node.hasAttribute('hidden')
    && !/display: ?none/.test(node.getAttribute('style') || ''));
  const sync = () => document.body.classList.toggle('pu-cookie-banner-open', isShown(banner));
  const bannerObserver = new MutationObserver(sync);
  const find = () => {
    const next = document.getElementById('shopify-pc__banner');
    if (next !== banner) {
      bannerObserver.disconnect();
      banner = next;
      if (banner) bannerObserver.observe(banner, { attributes: true, attributeFilter: ['hidden', 'style'] });
    }
    sync();
  };
  new MutationObserver(find).observe(document.body, { childList: true });
  find();
})();

(function () {
  let lastInputWasPointer = false;
  document.addEventListener('pointerdown', function () { lastInputWasPointer = true; }, true);
  document.addEventListener('keydown', function () { lastInputWasPointer = false; }, true);
  function restoreFocus(el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    if (lastInputWasPointer) {
      el.classList.add('pu-no-ring');
      el.addEventListener('blur', function onBlur() { el.classList.remove('pu-no-ring'); el.removeEventListener('blur', onBlur); });
    }
  }
  window.ProjectUnity = window.ProjectUnity || {};
  window.ProjectUnity.restoreFocus = restoreFocus;

  document.querySelectorAll('[data-project-unity]').forEach(function (root) {
  if (root.dataset.puCoreReady === 'true') return;
  root.dataset.puCoreReady = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const resizeOpenFaqAnswers = function () {
    if (window.ProjectUnityFaq) window.ProjectUnityFaq.initialise(root);
    if (window.ProjectUnityFaq) window.ProjectUnityFaq.resize(root);
  };
  resizeOpenFaqAnswers();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resizeOpenFaqAnswers);

  const contactCallback = root.querySelector('.pu-contact__callback');
  if (contactCallback) contactCallback.open = true;

  const setupContactDialog = function (modalSelector, openSelector, closeSelector) {
    const dialog = document.querySelector(modalSelector);
    if (!dialog || dialog.dataset.initialised === 'true') return;

    dialog.dataset.initialised = 'true';
    let returnFocus = null;
    let previousOverflow = '';

    const resetAfterSend = function () {
      const stateRoot = dialog.querySelector('[data-pu-form-state]');
      if (stateRoot) {
        if (stateRoot.dataset.puFormState !== 'success') return;
        stateRoot.dataset.puFormState = 'idle';
        stateRoot.querySelectorAll('[data-pu-form-feedback]').forEach(function (node) { node.hidden = true; });
      } else {
        const sent = dialog.querySelectorAll('[data-pu-form-success]');
        if (!sent.length) return;
        sent.forEach(function (node) { node.remove(); });
      }
      dialog.querySelectorAll('[data-pu-form-fields]').forEach(function (fields) { fields.hidden = false; });
      dialog.querySelectorAll('form').forEach(function (form) { form.reset(); });
      if (window.history && window.history.replaceState && /contact_posted/.test(window.location.search)) {
        const url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    };

    const getFocusableElements = function () {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length;
      });
    };

    const closeDialog = function () {
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = previousOverflow;
      if (returnFocus) returnFocus.focus();
      resetAfterSend();
    };
    const openDialog = function (trigger) {
      if (trigger) {
        const assistOwner = trigger.closest && trigger.closest('[data-assist]');
        returnFocus = assistOwner ? assistOwner.querySelector('[data-assist-toggle]') || trigger : trigger;
      }
      if (!dialog.classList.contains('is-open')) previousOverflow = document.documentElement.style.overflow;
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      const closeButton = dialog.querySelector(closeSelector);
      if (closeButton) closeButton.focus();
    };

    document.querySelectorAll(openSelector).forEach(function (button) {
      button.setAttribute('aria-haspopup', 'dialog');
      if (dialog.id) button.setAttribute('aria-controls', dialog.id);
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openDialog(button);
      });
    });
    const closeButton = dialog.querySelector(closeSelector);
    if (closeButton) closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener('keydown', function (event) {
      if (!dialog.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }
      if (event.key !== 'Tab') return;

      const focusableElements = getFocusableElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      const first = focusableElements[0];
      const last = focusableElements[focusableElements.length - 1];
      if (focusableElements.indexOf(document.activeElement) === -1) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const stateRoot = dialog.querySelector('[data-pu-form-state]');
    const stateOwner = stateRoot && (stateRoot.closest('form[id]') || dialog.querySelector('[data-pu-form-id][id]'));
    const applyFormState = function (requireMatchingHash) {
      if (!stateRoot || !stateOwner) return;
      const state = stateRoot.dataset.puFormState;
      const hasResult = state === 'success' || state === 'error';
      const belongsToDialog = !requireMatchingHash || window.location.hash === '#' + stateOwner.id;
      const fields = stateRoot.querySelector('[data-pu-form-fields]');
      const feedbackItems = Array.prototype.slice.call(stateRoot.querySelectorAll('[data-pu-form-feedback]'));
      const matchingFeedback = stateRoot.querySelector(
        state === 'success' ? '[data-pu-form-success]' : '[data-pu-form-error]'
      ) || feedbackItems[0];

      feedbackItems.forEach(function (feedback) { feedback.hidden = true; });
      if (!hasResult || !belongsToDialog) {
        if (hasResult && !belongsToDialog) stateRoot.dataset.puFormState = 'idle';
        if (fields) fields.hidden = false;
        return;
      }

      if (fields) fields.hidden = state === 'success';
      if (matchingFeedback) matchingFeedback.hidden = false;
      openDialog(null);
      window.requestAnimationFrame(function () {
        if (matchingFeedback) matchingFeedback.focus({ preventScroll: true });
      });
    };

    if (stateRoot && typeof window.MutationObserver === 'function') {
      const stateObserver = new window.MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) { return mutation.attributeName === 'data-pu-form-state'; })) {
          applyFormState(false);
        }
      });
      stateObserver.observe(stateRoot, { attributes: true, attributeFilter: ['data-pu-form-state'] });
    }
    applyFormState(true);
    if (!stateRoot) {
      const legacySuccess = dialog.querySelector('[data-pu-form-success]');
      if (legacySuccess && !legacySuccess.hidden) {
        openDialog(null);
        legacySuccess.focus({ preventScroll: true });
      }
    }
  };

  setupContactDialog('[data-message-modal]', '[data-message-open]', '[data-message-close]');
  setupContactDialog('[data-email-modal]', '[data-email-open]', '[data-email-close]');
  });
})();

(function () {
  const assist = document.querySelector('[data-assist]');
  if (!assist || assist.dataset.initialised === 'true') return;
  assist.dataset.initialised = 'true';
  const toggle = assist.querySelector('[data-assist-toggle]');
  const panel = assist.querySelector('[data-assist-panel]');
  (function scheduleNudge() {
    if (!toggle || !window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var key = 'pu-assist-opened';
    var opened = false;
    try { opened = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (opened) return;
    var lastScroll = 0;
    var fired = 0;
    window.addEventListener('scroll', function () { lastScroll = Date.now(); }, { passive: true });
    toggle.addEventListener('click', function () {
      opened = true;
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    });
    toggle.addEventListener('animationend', function () { toggle.classList.remove('is-nudging'); });
    var attempt = function () {
      if (opened || fired >= 2) return;
      if (document.hidden || Date.now() - lastScroll < 900 || toggle.getAttribute('aria-expanded') === 'true') { window.setTimeout(attempt, 1500); return; }
      toggle.classList.remove('is-nudging');
      void toggle.offsetWidth;
      toggle.classList.add('is-nudging');
      fired += 1;
      if (fired < 2) window.setTimeout(attempt, 12000);
    };
    window.setTimeout(attempt, 4000);
  })();
  if (!toggle || !panel) return;
  function setAssistOpen(open) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  toggle.addEventListener('click', function () { setAssistOpen(panel.hidden); });
  document.addEventListener('click', function (event) {
    if (!panel.hidden && !assist.contains(event.target)) setAssistOpen(false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) { setAssistOpen(false); toggle.focus(); }
  });
  assist.querySelectorAll('[data-assist-close]').forEach(function (el) {
    el.addEventListener('click', function () { setAssistOpen(false); });
  });

  // Online 8am to 8pm UK time. Read the shop's clock rather than the visitor's,
  // so someone browsing from another timezone sees whether Edward is actually
  // at his desk.
  var statusEl = assist.querySelector('[data-assist-status]');
  if (statusEl) {
    var intro = assist.querySelector('.pu-assist-launcher__intro');
    var syncStatus = function () {
      var hour;
      try {
        hour = parseInt(new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/London', hour: 'numeric', hour12: false
        }).format(new Date()), 10);
      } catch (e) {
        hour = new Date().getHours(); // no Intl timezone support; fall back to local
      }
      var online = hour >= 8 && hour < 20;
      statusEl.textContent = online ? 'Edward is online' : 'Edward is offline';
      if (intro) intro.classList.toggle('is-offline', !online);
    };
    syncStatus();
    setInterval(syncStatus, 60000);
  }

  // The launcher is fixed, so it can end up over a dark section where a dark
  // pill has no contrast. Read what is actually behind it and invert.
  if (typeof document.elementsFromPoint !== 'function') return;

  function luminance(color) {
    const m = String(color).match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    const parts = m[1].split(',').map(parseFloat);
    if (parts.length > 3 && parts[3] < 0.5) return null; // effectively transparent
    const srgb = parts.slice(0, 3).map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  }

  function behindIsDark() {
    const rect = toggle.getBoundingClientRect();
    const y = rect.top + rect.height / 2;
    if (y < 0 || y > window.innerHeight) return false;
    const stack = document.elementsFromPoint(rect.left + rect.width / 2, y);
    for (let i = 0; i < stack.length; i++) {
      const el = stack[i];
      if (assist.contains(el)) continue;
      // Escape hatch for photographic sections, whose background-color is
      // transparent and so cannot be measured.
      const declared = el.closest('[data-launcher-contrast]');
      if (declared) return declared.getAttribute('data-launcher-contrast') === 'dark';
      const lum = luminance(getComputedStyle(el).backgroundColor);
      if (lum !== null) return lum < 0.4;
    }
    return false;
  }

  let timer = 0;
  let onDark = null;
  function syncContrast() {
    timer = 0;
    const dark = behindIsDark();
    if (dark === onDark) return;
    onDark = dark;
    assist.classList.toggle('is-on-dark', dark);
  }
  function scheduleContrast() { if (!timer) timer = setTimeout(syncContrast, 200); }

  window.addEventListener('scroll', scheduleContrast, { passive: true });
  window.addEventListener('resize', scheduleContrast);
  // The first check can run before the non-blocking stylesheets have applied; check again once
  // everything has loaded so the result does not depend on which finished first.
  window.addEventListener('load', scheduleContrast, { once: true });
  scheduleContrast();
})();

(function () {
  const header = document.querySelector('.app-clinic-grid-header');
  if (!header || !document.querySelector('.pu-hero') || header.dataset.scrollStateInitialised === 'true') return;
  header.dataset.scrollStateInitialised = 'true';
  let solid = null;
  let ticking = false;
  function update() {
    ticking = false;
    const next = window.scrollY > 16;
    if (next !== solid) {
      solid = next;
      header.classList.toggle('pu-header-solid', solid);
    }
  }
  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('pageshow', requestUpdate);
  update();
})();

(function () {
  const header = document.querySelector('.app-clinic-grid-header');
  if (!header || header.dataset.metricsInitialised === 'true') return;
  header.dataset.metricsInitialised = 'true';

  let metricsFrame = 0;

  function updateHeaderMetrics() {
    const rect = header.getBoundingClientRect();
    const headerBottom = Math.max(0, Math.ceil(rect.bottom));
    document.documentElement.style.setProperty('--pu-header-bottom', headerBottom + 'px');
    document.documentElement.style.setProperty('--pu-header-height', Math.max(0, Math.ceil(rect.height)) + 'px');
  }

  function requestHeaderMetrics() {
    if (!metricsFrame) {
      metricsFrame = window.requestAnimationFrame(function () {
        metricsFrame = 0;
        updateHeaderMetrics();
      });
    }
  }

  /* The phone header has a single stable block size. Measure synchronously at
     startup and only remeasure for genuine viewport/element-size changes.
     Menu class changes deliberately do not trigger layout reads or delayed
     writes, so the first tap and every reopen reveal the drawer immediately. */
  updateHeaderMetrics();
  window.addEventListener('resize', requestHeaderMetrics, { passive: true });
  window.addEventListener('orientationchange', requestHeaderMetrics, { passive: true });
  window.addEventListener('pageshow', requestHeaderMetrics);
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(requestHeaderMetrics);
    observer.observe(header);
  }
})();
